'use strict';

angular.module('far.mountains')
.controller('RouteDescriptionController', function($log, FileUploader, mountainRoutes, fileUploadFilters, showModalMessage, $uibModal, $window, $http) {
	var showFilterError = false;

	var vm = {
        params: {
            mountainRoute: null,
            limit: 5,
            offset: 0
        },
		showPaging: true,
        total: {
            count: 0,
            pages: null
        },
        data: [],

		initUploadUrl: initUploadUrl,
		openSlider: openSlider,
		openRouteImagesUploader: openRouteImagesUploader,
		uploader: new FileUploader({
			url: '',
			autoUpload: true,
			filters: [
				fileUploadFilters.fileSize(),
				fileUploadFilters.fileType()
			],
			onSuccessItem: function (item, response) {
				item.serverData = response;
			},
			onWhenAddingFileFailed: function(item, filter) {
				if (showFilterError) return;

				var message = filter.message ? filter.message : 'Невозможно загрузить файл на сервер';

				showFilterError = true;
				var modalInstance = showModalMessage(message);
				modalInstance.result
					.then(function() {
						showFilterError = false;
					}, function() {
						showFilterError = false;
					});
			},
			onErrorItem: function() {
				if (showFilterError) return;

				showFilterError = true;
				var modalInstance = showModalMessage('Невозможно загрузить файл на сервер');
				modalInstance.result
					.then(function() {
						showFilterError = false;
					}, function() {
						showFilterError = false;
					});
			}
		}),
		getFileLink: function(file) {
			if (file.isUploading) {
				return '';
			}

			if (file.isSuccess) {
				return Routing.generate('api_upload_get_file', {'fileStorage': file.serverData.id});
			}

			return '';
		},
        submit: function ( next ) {
            if (vm.submitted) {
                return false;
            }

            vm.params.mountainRoute = vm.mountainRoute.id;

            if ( !next ) {
                vm.params.offset = 0;


                vm.total.count = 0;
                vm.total.pages = null;

                vm.data = [];
            }

            vm.submitted = true;

            $http.get(Routing.generate('api_entities_get_mountain_route_ascents', vm.params)).then(function (response) {
                vm.total.count = response.headers('X-Total-Count');
                vm.total.pages = Math.ceil( vm.total.count / vm.params.limit );

                if ( response.data ) {
                	if (response.data.html) {
						$('.mountain-route-ascents').append($(response.data.html));
					} else {
						vm.showPaging = false;
					}
                }

                vm.submitted = false;
                vm.loaded = false;
            }, function errorCallback(response) {
                $log.error(response);

                vm.submitted = false;
            });
        },
        next: function () {
            vm.params.offset += vm.params.limit;

            vm.submit( true );
        }
	};

	function initUploadUrl(id) {
		vm.uploader.url = Routing.generate('api_upload_post_mountainroute_file', {'id': id});
		vm.mountainRoute = mountainRoutes.get(id);
	}

	function openSlider(slide) {
		$uibModal.open({
			templateUrl: '/modals/slider/slider.html',
			controller: 'SliderController as slider',
			resolve: {
				slides: function() {
					return vm.mountainRoute.slides_files;
				},
				selectedSlide: function() {
					return slide;
				}
			}
		});
	}

	function openRouteImagesUploader(isAdmin) {
		var modalRouteImagesInstance = $uibModal.open({
			templateUrl: '/modals/mountain-route-images/mountain-route-images.html',
			controller: 'MountainRouteImagesController as routeImages',
			windowClass: 'modal-route',
			backdrop: 'static',
			keyboard: false,
			resolve: {
				mountainRoute: function() {
					return vm.mountainRoute;
				},
				isAdmin: function() {
					return isAdmin
				}
			}
		});

		modalRouteImagesInstance.result.then(
			function() {
				//$window.location.reload(true);
			},
			function(result) {
				if (result && result.error) {
					showModalMessage(result.error);
				}
			}
		);
	}

	return vm;
});
